<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Sub Project Name *"
                  v-model="formSchema.sub_project_name"
                  :rules="[v => !!v || 'Sub project name is required !', lng200]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Sector Name *"
                  item-text="name_with_sn"
                  item-value="id"
                  v-model="formSchema.sector_id"
                  :items="SectorIdList"
                  :rules="[v => !!v || 'Sector name is required !']"
                  required
                  @input="changeSecotr(formSchema.sector_id)"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Sub Sector Name"
                  item-text="sub_sector_name"
                  item-value="id"
                  v-model="formSchema.sub_sector_id"
                  :items="SubSectorIdList"
                ></v-autocomplete>
              </v-flex> 

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Sub-Project Location"
                  item-text="location_name"
                  item-value="id"
                  v-model="formSchema.location_id"
                  :items="LocationIdList"
                ></v-autocomplete>
              </v-flex>                

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'project_start_date', fieldValue:formSchema.project_start_date, label:'Sub Project Start Date'}"                  
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'project_end_date', fieldValue:formSchema.project_end_date, label:'Sub Project End Date', minDate:formSchema.project_start_date}"
                  ref="setRange"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Client Name *"
                  item-text="client_name"
                  item-value="id"
                  v-model="formSchema.client_id"
                  :items="ClientIdList"
                  :rules="[v => !!v || 'Client id is required !']"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'agreement_date', fieldValue:formSchema.agreement_date, label:'Agreement Date', required:''}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Moratorium Period (Months) *"
                  v-model="formSchema.moratorium_period"
                  :rules="[v => !!v || 'Moratorium period is required !',decimal]"
                  required
                  type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field label="Comments" v-model="formSchema.comments"></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <table width="100%" class="SubP-table">
                  <tr>
                    <th>Sanction Amount (GoB)</th>
                    <th>Sanction Amount (IDA)</th>
                    <th>Total Sanction Amount</th>
                  </tr>
                  <tr>
                    <td>
                      <v-text-field label="USD" v-model="formSchema.gob_usd" type="number" @keyup="changeAmount" ></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="USD" v-model="formSchema.ida_usd" type="number" @keyup="changeAmount"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="USD" v-model="formSchema.usd_total" readonly></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <v-text-field label="BDT" v-model="formSchema.gob_bdt" @keyup="changeAmount"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="BDT" v-model="formSchema.ida_bdt" @keyup="changeAmount"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="BDT" v-model="formSchema.bdt_total"></v-text-field>
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema"],

  components: {
    DatePicker
  },

  data: () => ({
    valid: true,

    SectorIdList: [],
    LocationIdList: [],
    SubSectorIdList: [],
    ClientIdList: []
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Sub Project Information"
        : "Add Sub Project Information";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    commonService.getAllData("drodown-data-for-subProInfo").then(res => {
      res.SectorList.forEach((item, full,index) => {
         item.name_with_sn = item.short_name ? item.sector_name +' ('+item.short_name+')' : item.sector_name
      })
      this.SectorIdList = res.SectorList;
      //this.SubSectorIdList = res.SubSectorIdList;
      this.ClientIdList = res.ClientInfoList;
      this.LocationIdList = res.LocationList;
    });    
  },

  watch:{
    formSchema(){
      this.changeSecotr(this.formSchema.sector_id);
    }    
  },

  methods: {

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "project_start_date"){
        this.formSchema.project_end_date = ''
        //console.log('data.value', data.value);
        this.$refs.setRange.setRange(data.value);
      }
    },

    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      var formSchema = this.formSchema;
      formSchema.project_start_date = this.changeFormateYMD(
        formSchema.project_start_date
      );
      formSchema.project_end_date = this.changeFormateYMD(
        formSchema.project_end_date
      );
      formSchema.agreement_date = this.changeFormateYMD(
        formSchema.agreement_date
      );

      if (formSchema.id > 0) {
        commonService
          .updateFormData(formSchema, "sub-project-info")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
      } else {
        commonService
          .insertFormData(formSchema, "sub-project-info")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
      }
    },

    changeSecotr(sector_id)
    {
      if(sector_id > 0){
        commonService.getAllDataById(sector_id, "get-subsector-list").then(res =>{        
          this.SubSectorIdList = res.data;
        });      
      }
    },

    changeAmount(){
      var formSchema = this.formSchema
      formSchema.usd_total = Number(formSchema.gob_usd) + Number(formSchema.ida_usd);
      formSchema.bdt_total = Number(formSchema.gob_bdt) + Number(formSchema.ida_bdt);
    },

    resetForm()
    {     
     this.formSchema.project_start_date = '';
     this.formSchema.project_end_date = '';
     this.formSchema.agreement_date = '';
     this.$refs.form.reset();
     this.formSchema.id = 0;
    },

    close: function(data) {
      if (data.status == 1) {
        this.resetForm();
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>

<style scoped>
table.SubP-table {
  margin-top: 20px;
  border-collapse: collapse;
  border: 1px solid #ccc;
}
table.SubP-table tr th {
  border: 1px solid #ccc;
  height: 48px;
}
table.SubP-table tr td {
  padding-left: 4px;
  border-right: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/subProjectInfo/insertForm.vue